import Cookies from 'js-cookie';
import { isString } from 'tcheck';
import { setAuthTokensToLocalStorage } from '../composables/useMobileLogin';

const idTokenKey = 'cognitoIdToken';
const accessTokenKey = 'cognitoAccessToken';
const refreshTokenKey = 'cognitoRefreshToken';
const logoutURLKey = 'logoutResponseUrl';

const cognitoExpiresKey = 'cognitoExpiresIn';
const cognitoTokenTypeKey = 'cognitoTokenType';

/**
 * Removes a series of cookies from the page on the .myqsrsoft.com
 * domain
 * @param logoutKey Whether to remove the logoutResponseUrl cookie
 */
function removeLoginCookies(logoutKey = true) {
  const keys = [
    idTokenKey,
    accessTokenKey,
    refreshTokenKey,
    cognitoExpiresKey,
    cognitoTokenTypeKey,
  ];

  if (logoutKey) {
    keys.push(logoutURLKey);
  }

  const domain = '.myqsrsoft.com';
  keys.forEach((key) => Cookies.remove(key, { domain }));
}

/**
 * Retrieves values from the Cookies set by createUserWithEID lambda
 * in the SSO repo. The lambda opens an HTML file that sets 4 separate
 * cookies:
 * - AccessToken
 * - RefreshToken
 * - IdToken
 * - ExpiresIn
 * - TokenType
 *
 * This function will extract the data needed for logging in from
 * the cookies and then set them correctly into the localStorage
 */
export function eidLoginHandler() {
  try {
    const idToken = Cookies.get(idTokenKey);
    const accessToken = Cookies.get(accessTokenKey);
    const refreshToken = Cookies.get(refreshTokenKey);
    // const logoutResponseUrl = Cookies.get(logoutURLKey);

    if (
      !isString(idToken) ||
      !isString(accessToken) ||
      !isString(refreshToken)
    ) {
      // We will only work if all the values are present
      removeLoginCookies();
      return;
    }

    setAuthTokensToLocalStorage({
      accessToken,
      idToken,
      refreshToken,
    });

    // Send false, because we're logging in
    removeLoginCookies(false);
  } catch (e) {
    console.error('Error in eidLoginHandler:', e);
  }
}
